import axios from "axios";

class EverestAdminRepository {

  findMe(params, callback) {
    axios.get("/v1/api/everest-admin/me")
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  /** MOUNTAIN  */

  createMountain(params, callback) {
    axios.post("/v1/api/everest-admin/mountains", params)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  searchMountain(params, callback) {
    axios.get("/v1/api/everest-admin/mountains", { params })
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  findMountain(params, callback) {
    axios.get(`/v1/api/everest-admin/mountains/${params.mountainId}`)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  updateMountain(params, callback) {
    axios.put(`/v1/api/everest-admin/mountains/${params.mountainId}`, params)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  deleteMountain(params, callback) {
    axios.delete(`/v1/api/everest-admin/mountains/${params.mountainId}`)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  /** PEAK */

  createMountainPeak(params, callback) {
    axios.post("/v1/api/everest-admin/mountain-peaks", params)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  getMountainPeakSearchForm(params, callback) {
    axios.get("/v1/api/everest-admin/mountain-peaks/search-form", { params })
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  searchMountainPeak(params, callback) {
    axios.get("/v1/api/everest-admin/mountain-peaks", { params })
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  findMountainPeak(params, callback) {
    axios.get(`/v1/api/everest-admin/mountain-peaks/${params.mountainPeakId}`)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  updateMountainPeak(params, callback) {
    axios.put(`/v1/api/everest-admin/mountain-peaks/${params.mountainPeakId}`, params)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  representMountainPeak(params, callback) {
    axios.put(`/v1/api/everest-admin/mountain-peaks/${params.mountainPeakId}:represent`)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  deleteMountainPeak(params, callback) {
    axios.delete(`/v1/api/everest-admin/mountain-peaks/${params.mountainPeakId}`)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  /** Location */

  createMountainLocation(params, callback) {
    axios.post(`/v1/api/everest-admin/mountains/${params.mountainId}/locations`, params)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  searchMountainLocation(params, callback) {
    axios.get(`/v1/api/everest-admin/mountains/${params.mountainId}/locations`)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  deleteMountainLocation(params, callback) {
    axios.delete(`/v1/api/everest-admin/mountains/${params.mountainId}/locations`, { params })
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  /**
   * LEAGUE
   */

  createLeague(params, callback) {
    axios.post("/v1/api/everest-admin/leagues", params)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  searchLeague(params, callback) {
    axios.get("/v1/api/everest-admin/leagues", { params })
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  findLeague(params, callback) {
    axios.get(`/v1/api/everest-admin/leagues/${params.leagueId}`)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  updateLeague(params, callback) {
    axios.put(`/v1/api/everest-admin/leagues/${params.leagueId}`, params)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  deleteLeague(params, callback) {
    axios.delete(`/v1/api/everest-admin/leagues/${params.leagueId}`)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  /** LEAGUE PEAK */

  searchLeagueForMountainPeak(params, callback) {
    axios.get(`/v1/api/everest-admin/leagues/${params.leagueId}/mountain-peaks`, params)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  updateLeagueForMountainPeak(params, callback) {
    axios.put(`/v1/api/everest-admin/leagues/${params.leagueId}/mountain-peaks`, params)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  /** DONG OF ADMIN */

  searchRegion1(params, callback) {
    axios.get(`/v1/api/everest-admin/dong-of-admin/region1s`)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  searchRegion2(params, callback) {
    axios.get(`/v1/api/everest-admin/dong-of-admin/region1s/${params.region1}`)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }

  /** USER STAMP */

  stamp(params, callback) {
    axios.post("/v1/api/everest-climber/mountain-peaks:stamp", params)
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }
}

export { EverestAdminRepository };
